var _desc, _defs, _rect, _g, _g2, _g3, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAggrevision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 675,
    viewBox: "0 0 1200 675",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "AggreVision project preview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A driver face with computer vision landmarks, emotion indicators, and an Affectiva EMPath label.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#211917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3a242d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#315c51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scan",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3b7ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fffefa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8decf"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 24,
    stdDeviation: 24,
    floodColor: "#130f0d",
    floodOpacity: 0.28
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    stroke: "#fffefa",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 142h996M96 246h996M96 350h996M96 454h996M96 558h996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 74v528M348 74v528M516 74v528M684 74v528M852 74v528M1020 74v528"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22,
    fill: "#fffefa"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 116,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 532,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 132,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1064,
    cy: 516,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 104,
    r: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 110,
    width: 984,
    height: 468,
    rx: 18,
    fill: "#fffefa",
    fillOpacity: 0.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 148,
    width: 300,
    height: 54,
    rx: 27,
    fill: "#211917"
  }), /*#__PURE__*/React.createElement("text", {
    x: 296,
    y: 184,
    fill: "#fffefa",
    fontFamily: "Arial, sans-serif",
    fontSize: 25,
    fontWeight: 800,
    textAnchor: "middle"
  }, "Affectiva EMPath"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172 234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 28c92-42 192-26 250 38 52 58 62 149 28 226-41 94-154 143-255 111C41 371-16 262 15 163 31 111 67 52 120 28Z",
    fill: "#ead0db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 174c30-30 68-31 104-5M254 170c38-27 76-23 104 8",
    fill: "none",
    stroke: "#211917",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 206,
    r: 14,
    fill: "#211917"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 206,
    r: 14,
    fill: "#211917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 220c-14 34-10 61 18 78",
    fill: "none",
    stroke: "#8d3151",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 342c58 32 121 30 188-5",
    fill: "none",
    stroke: "#211917",
    strokeWidth: 14,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#8d3151",
    strokeWidth: 4,
    fill: "none",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 136,
    width: 132,
    height: 108,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 136,
    width: 136,
    height: 108,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 244v34M310 244v34M206 190h36"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#315c51"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 152,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 172,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 156,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 182,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232,
    cy: 300,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 350,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 338,
    r: 6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(666 214)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fill: "#8d3151",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 900,
    letterSpacing: 4
  }, "EXPRESSION SIGNAL"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42,
    width: 302,
    height: 28,
    rx: 14,
    fill: "#ded8d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42,
    width: 236,
    height: 28,
    rx: 14,
    fill: "#8d3151"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 116,
    fill: "#315c51",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 900,
    letterSpacing: 4
  }, "DRIVER SAFETY LOCK"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 158,
    width: 302,
    height: 28,
    rx: 14,
    fill: "#ded8d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 158,
    width: 268,
    height: 28,
    rx: 14,
    fill: "#315c51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 248h300",
    stroke: "#211917",
    strokeWidth: 2,
    strokeOpacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#scan)",
    strokeWidth: 7,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 302c41-46 82-48 124-6s84 36 128-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 352c49-28 92-23 129 16s80 41 130 4"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 226,
    width: 396,
    height: 408,
    rx: 14,
    fill: "none",
    stroke: "url(#scan)",
    strokeWidth: 5,
    strokeDasharray: "16 14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 236h82M436 634h82M518 236v82M122 552v82",
    stroke: "#f3b7ba",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggrevision);
export default __webpack_public_path__ + "static/media/aggrevision.f12fd3288471a6d865dbba203cad1404.svg";
export { ForwardRef as ReactComponent };